import React, { useState, useEffect } from 'react'
import "react-data-table-component-extensions/dist/index.css";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import endpoint from "../../context/endpoint";
import { Context } from "../../context/Context";
import { CForm } from "@coreui/react";
import { DropdownButton, ButtonGroup, Card, Button, Row, Col, InputGroup, Dropdown, Modal, FormGroup, Form, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import Loader from "../Loader/loader";

const StaffDueForConfirmation = () => {
    const [isLoading, setLoading] = useState(false)
    const [show, setShow] = useState(false);
    const [showAdd, setAdd] = useState(false);

    const columns = [
        {
            name: "S/N",
            cell: (row, index) => (index + 1),
            width: "65px",
        },
        {
            name: "FILENO.",
            selector: (row) => [row.fileno],

            style: { textAlign: 'right' },
            sortable: true,

            width: "180px",
            // cell: (row) =>
            //     <div className="fs-12 fw-bold ">NJC/P/0987</div>
            // ,
        },
        {
            name: "FULLNAME",
            selector: (row) => [row.fullname],

            style: { textAlign: 'right' },
            sortable: true,

            // width: "200px",
            // cell: (row) =>
            //     <div className="fs-12 fw-bold ">Mr. ABIDJAN JUACHIN Moj</div>
            // ,
        },
        {
            name: "DATE OF APPOINTMENT",
            selector: (row) => [row.date_of_first_appointment],

            style: { textAlign: 'center' },
            sortable: true,

            // width: "200px",
            // cell: (row) =>
            //     <div className="fs-12 fw-bold ">1/2/2012</div>
            // ,
        },
        {
            name: "ACTION",
            selector: (row) => [],

            style: { textAlign: 'right' },
            cell: (row) => (
                <div className="fs-12 fw-bold">
                    <button
                        className="btn btn-success btn-sm my-1"
                        variant="success"
                        onClick={() => setAdd(true)}
                    >
                        <span className="fe fe-fast-forward"> Confirm Staff </span>
                    </button>
                </div>
            )
        }

    ]

    const data = [
        {
            id: 1,
            fileno: "NJC/P/0987",
            fullname: "Mr. ABIDJAN JUACHIN Moj",
            date_of_first_appointment: "1/2/2012"
        },
        {
            id: 1,
            fileno: "NJC/P/1027",
            fullname: "Mr. AHMNED ALMANI JIFFA",
            date_of_first_appointment: "1/2/2014"
        }
    ];

    const tableDatas = {
        columns,
        data,
    };

    return (
        <>
            {
                <DataTableExtensions {...tableDatas}>
                    {isLoading ? <Loader />
                        : <DataTable
                            fixedHeader
                            columns={columns}
                            // selectableRows
                            data={data}
                            // customStyles={customStyles}
                            persistTableHead
                            defaultSortField="id"
                            defaultSortAsc={false}
                            striped={true}
                            center={true}
                            pagination
                            paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangePage={handlePageChange}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
                            // onChangeRowsPerPage(currentRowsPerPage, currentPage)
                            // paginationPerPage={perPage}
                            highlightOnHover
                        />
                    }

                </DataTableExtensions>
            }

            {/* modal to confirm staff */}
            <Modal show={showAdd} >
                <Modal.Header >
                    <Button
                        onClick={() => setAdd(false)}
                        className="btn-close"
                        variant=""
                    >
                        x
                    </Button>
                </Modal.Header>
                <form>
                    <Modal.Body>
                        <div>
                            <Card>
                                <Card.Header>
                                    <Card.Title as="h3"> Reason For Confirmation </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Col lg={12} md={12}>
                                        <FormGroup>
                                            <label htmlFor="exampleInputname">Enter Reason</label>
                                            <textarea
                                                className="form-control is-invalid"
                                                id="validationTextarea"
                                                placeholder="Required example textarea"
                                                required
                                            ></textarea>
                                        </FormGroup>
                                    </Col>

                                </Card.Body>
                            </Card>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="warning" className="me-1" onClick={() => setAdd(false)}>
                            Close
                        </Button>
                        <Button type="button" variant="success" onClick={() => setAdd(false)}className="me-1">
                            <span className="fe fe-arrow-up"> Confirm staff </span>
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            {/* end modal to confirm staff*/}

        </>
    )
}

export default StaffDueForConfirmation